export default "__VITE_ASSET__05253613__"